import type { SVGProps } from "react";

export const CompassIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className="fill-current"
      {...props}
    >
      <path
        d="M12 3.75C16.5563 3.75 20.25 7.44365 20.25 12C20.25 16.5563 16.5563 20.25 12 20.25C7.44365 20.25 3.75 16.5563 3.75 12C3.75 7.44365 7.44365 3.75 12 3.75ZM12 5.25C8.27208 5.25 5.25 8.27208 5.25 12C5.25 15.7279 8.27208 18.75 12 18.75C15.7279 18.75 18.75 15.7279 18.75 12C18.75 8.27208 15.7279 5.25 12 5.25ZM14.9424 8.1084C15.2119 8.01861 15.5091 8.08919 15.71 8.29004C15.9106 8.49091 15.9804 8.78824 15.8906 9.05762L14.3008 13.8271C14.226 14.0509 14.05 14.2272 13.8262 14.3018L9.05664 15.8916C8.78732 15.9813 8.48987 15.9115 8.28906 15.7109C8.0883 15.5102 8.01879 15.2127 8.1084 14.9434L9.69727 10.1729C9.77187 9.94905 9.94814 9.77298 10.1719 9.69824L14.9424 8.1084ZM11.002 11.0029L10.0049 13.9941L12.9961 12.9971L13.9932 10.0049L11.002 11.0029Z"
        fill="currentColor"
      />
    </svg>
  );
};
